import "./SecurityChoose.css";
import img from "../securityassets/securitychoose.png";
import check from "../securityassets/check.png";

const securityChooseList = [
  {
    title: "Proven DevOps & Security Expertise",
    description:
      "Extensive experience delivering DevSecOps, cloud security, and compliance solutions across complex enterprise and regulated environments.",
  },
  {
    title: "End-to-End Cloud Security",
    description:
      "Comprehensive security coverage across cloud infrastructure, applications, CI/CD pipelines, and containerized environments.",
  },
  {
    title: "Compliance & Risk Management",
    description:
      "Expertise in implementing and managing security controls aligned with industry standards and regulatory requirements.",
  },
  {
    title: "Continuous Monitoring & Threat Detection",
    description:
      "Proactive monitoring, vulnerability management, and real-time threat detection to ensure secure and resilient systems.",
  },
];

export default function SecurityChoose() {
  return (
    <div id="security-choose" className="outsourcemainclass">
      <h1 className="heading">Our Configuration Management Capabilities</h1>
      <p className="subheading">
        Ensuring Consistency, Control, and Automation Across Environments
      </p>

      <div className="choose-container">
        <div className="left">
          <img src={img} alt="security choose" />
        </div>

        <div className="right">
          <ul>
            {securityChooseList.map((item, index) => (
              <li key={index}>
                <span className="image">
                  <img src={check} alt="check" />
                </span>

                <div>
                  <p>{item.title}</p>
                  <span>{item.description}</span>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
